<span [class]="getCssClass()">
    {{getLabel()}}
</span>
